import React from "react"
import "react-app-polyfill/stable"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import App from "./App"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import { persistor, store } from "./store"

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
)
reportWebVitals()
